import type { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import type { UserRoles } from '@handover/shared-types';
import { useAppSelector } from '../hooks/reduxHooks';
import {
  hasRequiredRole,
  isPlatformOwner,
} from '../helpers/platformAccessHelper';

type RouteGuardProps = PropsWithChildren<{
  allowedRoles?: UserRoles;
  requirePlatformOwner?: boolean;
  redirectTo?: string;
}>;

export const RouteGuard = ({
  allowedRoles,
  requirePlatformOwner = false,
  redirectTo = '/my-work',
  children,
}: RouteGuardProps) => {
  const { userAuth } = useAppSelector(state => state.auth);

  if (!userAuth) {
    return <Navigate to="/auth/login" replace />;
  }

  if (allowedRoles && !hasRequiredRole(userAuth, allowedRoles)) {
    return <Navigate to={redirectTo} replace />;
  }

  if (requirePlatformOwner && !isPlatformOwner(userAuth)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};
